import folderIcons from "./folderIcons";

const defaultFolderIcon = folderIcons[0].title;

export default defaultFolderIcon;
